import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import useWallet from '@hooks/useWallet';
import { getAggregatedAccount } from '@/services/actions';
import { devLog } from '@utils/helpers';

const AccountDataFetcher = () => {
  const { pathname } = useLocation();
  const { wallet } = useWallet();

  const { refetch } = useQuery({
    queryKey: ['account'],
    queryFn: () => (wallet ? getAggregatedAccount({ address: wallet.lsk32address }) : null),
    refetchInterval: 15000,
    keepPreviousData: true,
    staleTime: 15000,
    onSuccess: () => devLog('Account data fetched'),
  });

  useEffect(() => {
    devLog('Refetching..');
    refetch();
  }, [wallet, refetch]);

  useEffect(() => {
    if (pathname === '/dashboard') {
      devLog('Refetching..');
      refetch();
    }
  }, [pathname, refetch]);

  return null;
};

export default AccountDataFetcher;
